module.exports = "/build/web/svg/map-place.d84437732633dae6a735946dcfdb9521.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/map-place.svg
// module id = 90
// module chunks = 24